import configureSentry from '%app/js/common/services/configure-sentry';

export default function initSentry(appSettings) {
    configureSentry({ dsn: appSettings.sentryJsDsn });
}
